import { ROUTES_BILLING, ROUTES_BILLING_LICENCE_EXPIRED } from '@/constants/routes';
import store from '@/store';
import { guardRoute } from '@/router';

export default {
    path: '/billing',
    name: 'billing-main',
    component: () => import(/*webpackChunkName: 'settings'*/ '@/views/Billing.vue'),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/billing',
            name: ROUTES_BILLING,
            beforeEnter: guardRouteBilling,
            component: () => import(/*webpackChunkName: 'settings'*/ '@/components/settings/billing/Billing.vue')
        },
        {
            path: '/billing-licence-expired',
            name: ROUTES_BILLING_LICENCE_EXPIRED,
            component: () =>
                import(
                    /*webpackChunkName: 'settings'*/ '@/components/settings/billing-licence-expired/BillingLicenceExpired.vue'
                )
        }
    ]
};

function guardRouteBilling(to, from, next) {
    const unauthorized = !store.getters.isSelectedClubIndividual && !store.getters['userPermissions/canManageLicense'];
    guardRoute(next, unauthorized);
}
